var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.363 9.863a.631.631 0 110 1.263h-1.755v1.125h1.755a.628.628 0 01.61.877.632.632 0 01-.61.381H16.98a.63.63 0 01-.628-.63V8.11c0-.346.282-.631.628-.631h2.387a.631.631 0 01-.004 1.261H17.61v1.125h1.754zm-3.85 3.016a.634.634 0 01-.634.629.637.637 0 01-.512-.25l-2.441-3.32v2.94a.629.629 0 11-1.259 0v-4.77a.636.636 0 01.625-.629c.195 0 .375.106.496.254l2.46 3.328V8.108a.632.632 0 111.263 0l.001 4.771zm-5.743 0a.632.632 0 01-.633.63.63.63 0 01-.625-.63v-4.77c0-.347.282-.632.63-.632.347 0 .629.285.629.632v4.77zm-2.465.63H4.918a.634.634 0 01-.633-.63v-4.77a.632.632 0 111.262 0v4.14h1.758a.628.628 0 110 1.26zM24 10.311C24 4.94 18.613.57 12 .57S0 4.941 0 10.312c0 4.813 4.27 8.844 10.035 9.61.39.081.922.258 1.059.59.12.3.078.765.039 1.082l-.164 1.02c-.047.3-.242 1.183 1.047.644 1.293-.539 6.918-4.078 9.437-6.977C23.176 14.395 24 12.457 24 10.311z",
    fill: "#555"
  })));
}

export default SvgLine;